import { render, staticRenderFns } from "./assessment-resume.vue?vue&type=template&id=39ca180a&scoped=true&"
import script from "./assessment-resume.vue?vue&type=script&lang=ts&"
export * from "./assessment-resume.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-resume.vue?vue&type=style&index=0&id=39ca180a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ca180a",
  null
  
)

export default component.exports